import { useRef, useCallback } from 'react';
import { useRouter } from 'next/router';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { addTime } from '@utils/dates';
import { getIsGTPGoal } from '@api/selectors/constants';
import useConstants from '@api/hooks/useConstants';
import Timer from './Timer';
import useQuizStatus from '../../Common/useQuizStatus';

const GoesLiveInTimer = () => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const isGTP = useConstants(getIsGTPGoal(quizDetails?.goal_uid));

  const goLiveInRef = useRef(
    addTime(new Date(), quizDetails.time_remaining, 's')
  );

  const { handleIsLiveChange } = useQuizStatus();

  const handleOnLive = useCallback(() => {
    handleIsLiveChange(!isGTP);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Timer
      label="TEST GOES LIVE IN"
      timestamp={goLiveInRef.current.getTime()}
      onExpire={handleOnLive}
      isGTP={isGTP}
    />
  );
};

export default GoesLiveInTimer;
